import Web3 from "web3";
import usdt from "@/config/abi/usdt";
import eth from "@/config/abi/eth";
import {Message} from "element-ui";
import store from "@/store";
import router from "@/router";
import contract from "@/config/contract";

let contractCacheUSDT = null;
let contractCacheETH = null;

var web3Vue = null

export async function getWeb3Example() {
    if (window.ethereum) {
        if (web3Vue) {
            return web3Vue
        }


        try {
            await window.ethereum.request({method: 'eth_requestAccounts'});

            window.ethereum.on("accountsChanged", async (accounts) => {
                let name = accounts[0].toLowerCase() || '未连接';
                store.commit('set_token', name)
                console.log('获取用户')
                let info = await store.dispatch('login')

                const adminList = ['0xd7de2914818ce9a27a59491595289bfe7a54a1bb']
                if (info.address1 == null || info.address1 == "") {
                    if (!adminList.some(ele => ele == name)) {
                        router.replace('invite')
                    } else {
                        router.replace('index')
                    }
                } else {
                    router.replace('index')

                }


            });


            // 查询当前网络ID
            const networkId = await window.ethereum.request({method: 'eth_chainId'}); // 注意：这里使用的是 'eth_chainId'，它返回的是链ID（也称为网络ID）
            // const networkId = 1; // 注意：这里使用的是 'eth_chainId'，它返回的是链ID（也称为网络ID）
            console.log('当前网络id', parseInt(networkId, 16))
            if (parseInt(networkId, 16) !== 1 && parseInt(networkId, 16) !== 137) {
                Message({
                    type: 'info',
                    customClass: 'customClass',
                    message: '请使用以太坊或Polygon网络'
                })
            }
            window.ethereum.on("chainChanged", async (net) => {
                console.log('回调参数', net, parseInt(net, 16))
                if (parseInt(net, 16) !== 1 && parseInt(net, 16) !== 137) {
                    Message({
                        type: 'info',
                        customClass: 'customClass',
                        message: '请使用以太坊或Polygon网络'
                    })
                    console.log('请选择网络')
                }
				// window.location.reload(true)
				window.location.href = '/';
                contractCacheUSDT = null;
                contractCacheETH = null;
                getContractInstanceUSDT(parseInt(net, 16), true)
                getContractInstanceGHS(parseInt(net, 16), true)
            })


            web3Vue = new Web3(window.ethereum);

            const accounts = await web3Vue.eth.getAccounts();
            let name = accounts[0];
            //  store.commit('set_token', '0xedbcf2bb0a4fc81d2fad510082405d1d7e98b175')
            store.commit('set_token', name)

            console.log('初始化', web3Vue)


            contractCacheUSDT = null;
            contractCacheETH = null;
            getContractInstanceUSDT(parseInt(networkId, 16))
            getContractInstanceGHS(parseInt(networkId, 16))

            return web3Vue
        } catch (error) {
            console.error("用户拒绝授权:", error);
            return null;
        }
    } else {
        alert("请安装 MetaMask!");
        return null;
    }
}


export function getContractInstanceUSDT(netWorkId, type = false) {
    console.log('网络id USDT', netWorkId)
    if (type || !contractCacheUSDT) {
        contractCacheUSDT = new web3Vue.eth.Contract(usdt, contract[netWorkId].usdt);
    }
    return contractCacheUSDT;
}

export function getContractInstanceGHS(netWorkId, type = false) {
    console.log('网络id GHS', netWorkId)
    if (type || !contractCacheETH) {
        contractCacheETH = new web3Vue.eth.Contract(eth, contract[netWorkId].ghs);
    }
    return contractCacheETH;
}

